import { Button, ButtonActionBar, Typography } from 'modules/core/components'
import { DownloadOutlined } from '@ant-design/icons'

const TopTableActions = ({ onClick }) => {
  return (
    <ButtonActionBar>
      <Button.Icon
        title="ACTION_DOWNLOAD_TABLE"
        icon={<Typography.Icon icon={DownloadOutlined} />}
        onClick={onClick}
      />
    </ButtonActionBar>
  )
}

export default TopTableActions
